<div class="relative h-full w-full min-h-0">
  <input
    #fileInput
    type="file"
    class="hidden"
    [accept]="accept"
    [multiple]="multiple"
    [disabled]="disabled || isUploading"
    (change)="onInputChange($event)"
  />

  <div
    class="absolute inset-0 rounded-lg border border-dashed border-primary-border bg-white flex flex-col items-center justify-center px-24 py-32 text-center transition-colors"
    [class.border-highlight]="isDragging"
    [class.cursor-pointer]="!disabled && !isUploading"
    role="button"
    tabindex="0"
    [attr.aria-disabled]="disabled || isUploading"
    (click)="openFilePicker($event)"
    (keydown.enter)="openFilePicker($event)"
    (keydown.space)="openFilePicker($event)"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
  >
    <!-- pointer-events-none so the box above is always the drag target — without it, moving the
    pointer over this content mid-drag fires a dragleave/dragenter pair on the box, flickering
    `isDragging` off and on. -->
    <div class="flex flex-col items-center pointer-events-none">
      <ng-container *ngIf="placeholderIconSrc; else defaultIcon">
        <img [src]="placeholderIconSrc" [alt]="placeholderIconAlt" aria-hidden="true" class="h-40 w-40" />
      </ng-container>
      <ng-template #defaultIcon>
        <nz-empty nzNotFoundImage="simple" [nzNotFoundContent]="null" aria-hidden="true"></nz-empty>
      </ng-template>

      <div class="mt-16 text-base leading-6 font-semibold text-primary-text">
        {{ isUploading ? uploadingTitle : title }}
      </div>
      <div class="mt-8 text-sm leading-5 text-secondary-text">{{ description }}</div>
    </div>

    <div
      *ngIf="isDragging"
      class="absolute inset-0 rounded-lg bg-primary-light flex flex-col items-center justify-center gap-8 pointer-events-none"
    >
      <twaice-fe-svg-icon source="tabler" name="upload" size="32px" color="currentColor" class="text-primary-text" />
      <span class="text-base font-semibold text-primary-text">Release files here</span>
    </div>
  </div>

  <div *ngIf="validationError" class="mt-6 text-xs leading-5 text-red-600">{{ validationError }}</div>
</div>
